import { useMemo } from 'react';

import { FeatureFlag } from '@revelio/core';

import { useTabContentConfig } from '../../../next/CustomDash/components/PageConfigProvider/PageConfigProvider';
import { useUnleashFlag } from '../../unleash-flags/use-unleash-flag';
import { UserPreferenceKey } from '../types';
import { preferenceAdapters } from '../utils/preference-filter-adapters';

export function useCustomDashPreferenceVisibility() {
  const { hasFilter } = useTabContentConfig();
  const geographyUserPreferenceEnabled = useUnleashFlag(
    FeatureFlag.GeographyUserPreference
  );
  // Page order editor is only useful when the draggable tab bar is rendered.
  // Mirrors the flag check in AnalyticsViewTabs.
  const draggablePagesTabsEnabled = useUnleashFlag(
    FeatureFlag.DraggablePagesTabs
  );
  const newDashboardLayoutEnabled = useUnleashFlag(
    FeatureFlag.DashboardNewLayout
  );
  const pageOrderEditorEnabled =
    draggablePagesTabsEnabled || newDashboardLayoutEnabled;

  return useMemo(() => {
    return (key: UserPreferenceKey): boolean => {
      if (key === UserPreferenceKey.Geography) {
        return geographyUserPreferenceEnabled;
      }
      if (key === UserPreferenceKey.PageOrder) {
        return pageOrderEditorEnabled;
      }
      if (key === UserPreferenceKey.ColorMode) {
        return newDashboardLayoutEnabled;
      }
      if (key === UserPreferenceKey.Taxonomies) {
        return true;
      }
      const related = preferenceAdapters[key]?.relevantFilters ?? [];
      if (related.length === 0) return true;
      return related.every((filterId) => hasFilter(filterId));
    };
  }, [
    hasFilter,
    geographyUserPreferenceEnabled,
    pageOrderEditorEnabled,
    newDashboardLayoutEnabled,
  ]);
}
